import React from "react";
import styled from "styled-components";
import "./BlackjackPage.css";

export const theme = {
  colors: {
    // background: "#000000",
    text: "#FFFFFF",
    textSecondary: "#808080",
    primary: "#404040",
  },
  breakpoints: {
    mobile: "320px",
    tablet: "768px",
    desktop: "1024px",
  },
};

const BlackjackDesktopPage = () => {
  return (
    <div>
      <Container>
        <ImageSection>
          <div className="desktop-mockup">
            <iframe
              src="home-screen-blackjack-desktop.html"
              title="Blackjack UI"
              className="desktop-webapp-iframe"
            ></iframe>
          </div>
        </ImageSection>
        <ContentSection>
          <Title
            onClick={() => window.open("https://blackjack.danials.space", "_blank")}
            style={{ cursor: "pointer" }}
          >
            Blackjack
          </Title>
          <Description>
            Play classic Blackjack in your browser. Challenge yourself, test your luck, and enjoy a sleek, modern interface.
          </Description>
          <Feature>
            <a
              href="https://blackjack.danials.space"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              🃏 Play Now
            </a>
          </Feature>
          <FeatureList>
            <Feature>✦ Realistic card animations</Feature>
            <Feature>✦ Fast, responsive gameplay</Feature>
            <Feature>✦ No sign-up required</Feature>
          </FeatureList>
        </ContentSection>
      </Container>
    </div>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 90%;
  background-color: ${theme.colors.background};
  padding: 4rem 2rem;
  justify-content: space-between;
  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const ContentSection = styled.div`
  flex: 0.4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;

  @media (max-width: 1280px) {
    padding: 0;
  }
`;

const Title = styled.h1`
  font-size: 3rem;
  color: ${theme.colors.text};
`;

const Description = styled.p`
  font-size: 1.2rem;
  color: ${theme.colors.textSecondary};
  max-width: 37.5rem;
  line-height: 1.6;
`;

const ImageSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1400px) {
    display: none;
  }
`;

const FeatureList = styled.div`
  list-style: none;
  padding: 0;
  margin: 2rem 0;
  color: ${theme.colors.text};
  display: flex;
  flex-direction: column;
`;

const Feature = styled.div`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
`;

export default BlackjackDesktopPage;
